import RestockWaitPanel, { hasProductWaiting, isProductWaiting } from './RestockWaitPanel';
import WaitBellIcon from './WaitBellIcon';
import Block from './modal/Block';
import { handleChatComposerKeyDown } from '../../../Component/Support/chatComposerKeyboard';
import LiveExitModal from './modal/LiveExitModal';
import useLiveExitGuard from './useLiveExitGuard';
import CancelTicketLetter from './modal/CancelTicketLetter';
import { canPurchaseProduct, getProductSaleStatus, hasProductExposure, showExposurePrice } from "../../../Component/tool/productExposure";

import ExpandableNotice from "../../../Component/UI/ExpandableNotice";
import LiveStatusBadge from "../../../Component/UI/LiveStatusBadge";
/* eslint-disable react/jsx-pascal-case */

import { StatePage } from "../../../Component/UI/ContentState";
import axios from "axios";

import KaKaoban_page from "../../../Component/UI/kakaoban_page";
import { isKakaoTalkInAppBrowser } from "../../../Component/tool/kakaoBrowser";
import { useLiveAnalytics, trackLiveEvent } from "../../../Component/analytics/tracking";
import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import io, { Socket } from "socket.io-client";

import styled from "styled-components";

import Layout_user from "../../../Component/UI/Layout_user";

import url, { SERVER_ADDRESS, SOCKET_SERVER_URL } from "../../../Component/server";

import { Icon, RowView, CenterView } from "../../../Component/style/common_style";

import { amountFormat } from "../../../Component/tool/Tools";

import ChatComponent from "../../Chat/ChatComponent";

import LiveQaModal from "./modal/LiveQaModal";
import { qaUpdated, useLiveQa } from "../../Chat/liveQa";
import ScrollingLiveTitle from "../../../Component/UI/ScrollingLiveTitle";
import Buy_Modal from "./modal/Buy_Modal";
import Product_Intro_Modal from "./modal/Product_Intro_Modal";


import Delivery_Info_Modal from "./modal/Delivery_Info_Modal";

import type { InventoryUpdate } from "./inventory";
import { ViewerPurchaseNotices, useViewerPurchaseFeedback } from "./ViewerPurchaseFeedback";
import { PurchaseEffectsLayer, PurchaseSuccessLabel, purchaseSuccessButtonStyles, usePurchaseSuccessEffects } from "./PurchaseSuccess";
import ViewerProductStock from "./ViewerProductStock";
import { parseLiveClosingTime } from "./LiveClosingCountdown";
// import LiveClosingCountdown from "./LiveClosingCountdown"; // 종료 타이머 비활성화
import useLiveCouponProducts from "./useLiveCouponProducts";
import Item_List_Modal from "./modal/Item_List_Modal";

import Notice_Modal from "./modal/Notice_Modal";

import Live_Component, { LivePlayerHandle } from "./Live_Component";
import ReviewBlackPlayer from "./ReviewBlackPlayer";
import EndedLive from "./EndedLive";
import { useToken } from "../../../Component/Context/useToken";

import ProductImageViewer from "./modal/ProductImageViewer";
import { fontStyles } from "../../../Component/style/common_font";

import api, { restoreSession } from "../../../Component/axios_Interceptor/api";
import { useSaleProductInfo } from "./useSaleProductInfo";
import ProductThumbnail from '../../../Component/UI/ProductThumbnail';
import { mediaUrl } from '../../../Component/tool/mediaUrl';
import { useTimedExposure } from './useTimedExposure';
import { GTM_EVENTS, pushGtmEvent } from '../../../Component/analytics/gtm';
import ticketIcon from '../../../Image/ic_ticket.svg';


interface BuyBtnProps {

  $success?: boolean;
}

interface VolumeProps {

  value: number;

}

interface ChatComponentRef {

  sendMessage: () => Promise<boolean>;
}



export type live_info_type = {

  seq: number;

  integration_test?: boolean;
  live_start: string;

  live_finish: string;

  live_limit: number;

  live_title: string;

  live_img: string | null;

  live_status: string;

  crt_dt: string;

  send_check: string;

  start_dt: string;

  channel_name: string;
  store_seq: number;
  secret_yn: string;
  follow_yn?: string;
  store_name?: string;
  payment_mode?: string;
  payment_review_enabled?: boolean | number;
};
type live_notice_type = {

  seq: number;

  live_seq: number;

  type: string;

  title: string | null;

  content: string;

  crt_dt: string;

};

type props_data_type = {

  seq: number;

  live_seq: number;

  name: string;

  price: number;

  option_check: string;

  init_cnt: number;

  current_cnt: number;

  product_status: string;
  exposure_active?: boolean | null;
  exposure_price_mode?: 'visible' | 'seller' | 'hidden';
  product_num: number | null;

  unique_option1: string[];

  unique_option2: string[];

  thumbnail_img?: string | null;
};


function hasNoticeContent(content?: string) {
  if (typeof content !== 'string' || !content.trim()) return false;
  const body = new DOMParser().parseFromString(content, 'text/html').body;
  return Boolean(body.textContent?.replace(/[\s\u200b]/g, '') || body.querySelector('img'));
}

type LiveProps = { reviewMode?: boolean };

const Live = (props: LiveProps) => {
  const { pathname, search, hash } = useLocation();
  if (!props.reviewMode && isKakaoTalkInAppBrowser()) {
    return <KaKaoban_page key={pathname + search + hash} />;
  }
  return <LiveContent {...props} />;
};

const LiveContent = ({ reviewMode = false }: LiveProps) => {
  const Navigate = useNavigate();

  const { userinfoReturn } = useToken();

  const { state } = useLocation();
  const { seq } = useParams();

  const followPromptedStoreRef = useRef<number | null>(null);


  // 로그인 상태 및 로그인 유도 모달 상태 관리

  const [isLoginNeededModalOpen, setIsLoginNeededModalOpen] = useState(false);
  const [isFollowPromptOpen, setIsFollowPromptOpen] = useState(false);
  const [followBusy, setFollowBusy] = useState(false);
  const followRunning = useRef(false);
  const [isLogin, setIsLogin] = useState(false);
  const [reviewUserid, setReviewUserid] = useState('');
  const [reviewPassword, setReviewPassword] = useState('');
  const [reviewLoginBusy, setReviewLoginBusy] = useState(false);
  const [reviewLoginError, setReviewLoginError] = useState('');
  const [reviewCheckoutError, setReviewCheckoutError] = useState('');
  const [exitModalOpen, setExitModalOpen] = useState(false);
  useEffect(() => { setExitModalOpen(false); }, [seq]);


  const goKaKaoLogin = () => {

    const nextPath = window.location.pathname + window.location.search;
    sessionStorage.setItem("authReturnTo", nextPath);
    const loginUrl = new URL(url.Communication_url.kakao_login, window.location.origin);
    loginUrl.searchParams.set("nextPath", nextPath);
    window.location.assign(loginUrl.href);
  };



  const [blocked, setBlocked] = useState(false);
  const [dontShowFollow, setDontShowFollow] = useState(false);
  const [followPreferenceKey, setFollowPreferenceKey] = useState('');
  const [imageViewerOpen, setImageViewerOpen] = useState(false);


  useEffect(() => {
    let active = true;
    restoreSession().then(token => { if (active) setIsLogin(Boolean(token)); });
    return () => { active = false; };
  }, []);


  const [BuyModal, setBuyModal] = useState(false);

  const openBuy = () => setBuyModal(!BuyModal);

  const [IntroModal, setIntroModal] = useState(false);

  const openIntro = () => setIntroModal(!IntroModal);

  const [qaOpen, setQaOpen] = useState(false);
  const [NoticeModal, setNoticeModal] = useState(false);

  const openNotice = () => setNoticeModal(!NoticeModal);

  const [DeliveryInfoModal, setDeliveryInfoModal] = useState(false);

  const openDeliveryInfo = () => {
    if (!isLogin) { setIsLoginNeededModalOpen(true); return; }
    setDeliveryInfoModal(!DeliveryInfoModal);
  };
  const [ItemListModal, setItemListModal] = useState(false);

  const openItemList = () => setItemListModal(!ItemListModal);



  // 상품 팝업은 영상 재생 시점에 맞는 노출 신호를 받은 뒤 표시합니다.

  const [data, set_Data] = useState<props_data_type>({

    seq: 0,

    live_seq: Number(seq) || 0,

    name: "",

    price: 0,

    option_check: "n",

    init_cnt: 0,

    current_cnt: 0,

    product_status: "대기",

    product_num: null,

    unique_option1: [],

    unique_option2: [],

  });

  const [waitingGroups, setWaitingGroups] = useState<string[]>([]);
  useEffect(() => {
    if (hasProductExposure(data) && !showExposurePrice(data.exposure_price_mode)) {
      setIntroModal(false);
      setBuyModal(false);
    }
  }, [data.exposure_price_mode, data.exposure_active, data.product_status]);
  const onWaitJoined = (group: string) => setWaitingGroups(previous => previous.includes(group) ? previous : [...previous, group]);
  const latestStock = useRef(new Map<number, number>());
  const inventoryRevision = useRef(0);
  useEffect(() => { latestStock.current.clear(); inventoryRevision.current += 1; }, [seq]);
  const [live_info, set_Live_Info] = useState<live_info_type>();
  const [integrationHostState, setIntegrationHostState] = useState<{cameraMuted:boolean;micMuted:boolean}>();
  useEffect(() => {
    setIntegrationHostState(undefined);
    if (!live_info?.integration_test || reviewMode) return;
    let disposed = false;
    const controller = new AbortController();
    const refresh = async () => {
      try {
        const {data} = await axios.get(`${SERVER_ADDRESS}integration-tests/lives/${live_info.seq}`,{signal:controller.signal,timeout:10000});
        if (!disposed && data.publisher?.state === 'live') setIntegrationHostState({cameraMuted:Boolean(data.publisher.cameraMuted),micMuted:Boolean(data.publisher.micMuted)});
      } catch { /* Timed metadata remains the normal playback authority. */ }
    };
    void refresh();const timer = window.setInterval(refresh,3000);
    return () => { disposed=true;controller.abort();window.clearInterval(timer); };
  }, [live_info?.seq,live_info?.integration_test,reviewMode]);
  const exitGuard = useLiveExitGuard({
    enabled: isLogin && !reviewMode && !blocked && live_info?.live_status === '방송중',
    onExitRequested: () => setExitModalOpen(true),
  });
  useLiveAnalytics(live_info, Boolean(isLogin), reviewMode);
  const playedLiveRef = useRef<number | null>(null);
  const commonQa = useLiveQa(Number(seq), 'common', Boolean(live_info), isLogin);
  const mineQa = useLiveQa(Number(seq), 'mine', Boolean(live_info) && isLogin, isLogin);
  const hasQa = commonQa.items.length > 0 || mineQa.items.length > 0;
  const [liveError, setLiveError] = useState("");
  const [liveRetry, setLiveRetry] = useState(0);
  const exposure = useTimedExposure<props_data_type>(
    live_info && ['방송중', '리허설'].includes(live_info.live_status) && !reviewMode ? live_info.seq : undefined,
    item => {
      set_Data(previous => item && hasProductExposure(item)
        ? { ...item, current_cnt: latestStock.current.get(item.seq) ?? item.current_cnt } : { ...previous, exposure_active: false });
      setBuyModal(false);
    },
  );
  useEffect(() => {
    if (live_info && ['방송중', '리허설'].includes(live_info.live_status) && !reviewMode) {
      set_Data(previous => ({ ...previous, exposure_active: false }));
    }
  }, [live_info?.live_status, live_info?.seq, reviewMode]);

  const [live_notice, set_Live_Notice] = useState<live_notice_type>();
  const [hasRegularNotices, setHasRegularNotices] = useState(false);
  const noticeRequestRef = useRef({ ln: 0, rn: 0 });
  const [live_time, set_Live_Time] = useState<string>("00:00:00");

  const [viewer_count, set_Viewer_Count] = useState<number>(0);

  const [mesage, set_Mesage] = useState<string>("");

  const [all_visible, set_All_Visible] = useState(true);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const [isMuted, setIsMuted] = useState(false);

  const [playbackMuted, setPlaybackMuted] = useState(true);
  const livePlayerRef = useRef<LivePlayerHandle>(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const [ticketCount, setTicketCount] = useState(0);
  const [couponLetterRevision, setCouponLetterRevision] = useState(0);
  const currentUserSeqRef = useRef<number | null>(null);
  const [viewerNickname, setViewerNickname] = useState('');
  const ticketRequestRef = useRef(0);
  useEffect(() => {
    ticketRequestRef.current += 1;
    setTicketCount(0);
  }, [seq]);
  const [inventoryUpdate, setInventoryUpdate] = useState<InventoryUpdate>();
  const [inventorySyncVersion, setInventorySyncVersion] = useState(0);
  const [productListSyncVersion, setProductListSyncVersion] = useState(0);
  const productInfoSyncVersion = productListSyncVersion + inventorySyncVersion;
  const { images: productImages, inventory: productInventory, inventoryRevision: requestedInventoryRevision } = useSaleProductInfo(data.seq, true, productInfoSyncVersion, inventoryRevision.current);
  useEffect(() => {
    if (!productInventory || requestedInventoryRevision !== inventoryRevision.current) return;
    latestStock.current.set(productInventory.productSeq, productInventory.currentCnt);
    setInventoryUpdate(productInventory);
    set_Data(previous => previous.seq === productInventory.productSeq
      ? { ...previous, current_cnt: productInventory.currentCnt } : previous);
  }, [productInventory, requestedInventoryRevision]);
  useEffect(() => { setImageViewerOpen(false); }, [data.seq]);
  const [orderRevision, setOrderRevision] = useState(0);
  const couponAccess = useLiveCouponProducts(Number(seq), isLogin, orderRevision + inventorySyncVersion + productListSyncVersion, Boolean(live_info) && !reviewMode);

  const { notices: purchaseNotices, celebration, showPurchaseNotice, celebratePurchase } = useViewerPurchaseFeedback(seq,
    isLogin ? viewerNickname : undefined, Boolean(live_notice && hasNoticeContent(live_notice.content)));
  const purchaseSuccess = usePurchaseSuccessEffects(celebration, seq);
  // Local review can show the existing confirmed-purchase animation without placing an order.
  useEffect(() => {
    if (process.env.NODE_ENV === 'production' || !reviewMode || !document.querySelector('meta[name="fanbird-local-review"]')) return;
    const simulatePurchase = (event: Event) => {
      if ((event as CustomEvent).detail?.liveSeq === Number(seq)) celebratePurchase();
    };
    window.addEventListener('fanbird-local-review:purchase', simulatePurchase);
    return () => window.removeEventListener('fanbird-local-review:purchase', simulatePurchase);
  }, [seq, reviewMode, celebratePurchase]);

  const completeLivePurchase = () => {
    setBuyModal(false);
    setItemListModal(false);
    set_All_Visible(true);
    celebratePurchase();
  };
  useEffect(() => {
    if (!isLogin || ticketCount <= 0) setIsTooltipOpen(false);
  }, [isLogin, ticketCount]);
  const showPurchaseNotification = useCallback((content: string) => {
    setIsTooltipOpen(false);
    showPurchaseNotice(content);
  }, [showPurchaseNotice]);
  const refreshTickets = async () => {

    const request = ++ticketRequestRef.current;
    if (!isLogin || !seq) { currentUserSeqRef.current = null; setTicketCount(0); return; }
    try {

      await api.post(url.Communication_url.issue_cancel_ticket, { live_seq: Number(seq) });

      const res = await api.get(url.Communication_url.user_live_cancel_ticket, { params: { liveSeq: Number(seq) } });

      if (request === ticketRequestRef.current) {
        setTicketCount(Number(res.data.ticket_count) || 0);
      }
    } catch { /* Keep the last confirmed count during a temporary connection failure. */ }
  };

  useEffect(() => { refreshTickets(); }, [seq, isLogin]);



  const onOrderConfirmed = () => {
    setOrderRevision(revision => revision + 1);
    void refreshTickets();
  };

  const go_home = () => Navigate("/");


  const reviewLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!reviewUserid.trim() || !reviewPassword || reviewLoginBusy) return;
    setReviewLoginBusy(true); setReviewLoginError('');
    try {
      const result = await axios.post(url.Communication_url.user_login,
        { userid: reviewUserid.trim(), userpw: reviewPassword }, { withCredentials: true, timeout: 20000 });
      if (!result.data?.accessToken) throw new Error('로그인 결과를 확인하지 못했습니다.');
      for (const storage of [localStorage, sessionStorage]) {
        storage.removeItem('key'); storage.removeItem('authority');
      }
      if (!await restoreSession()) throw new Error('로그인 세션을 확인하지 못했습니다. 다시 시도해주세요.');
      setReviewPassword(''); setIsLogin(true); setIsLoginNeededModalOpen(false);
    } catch (failure: any) {
      setReviewLoginError(failure?.response?.status === 401 ? '아이디와 비밀번호를 확인해주세요.' : failure?.message || '로그인을 처리하지 못했습니다.');
    } finally { setReviewLoginBusy(false); }
  };

  const completeReviewPurchase = () => {
    setBuyModal(false); setItemListModal(false); setReviewCheckoutError('');
    void api.get(url.Communication_url.order_info, { params: { live_seq: Number(seq) } })
      .then(({ data: result }) => {
        const orderSeq = Number(result?.order?.seq);
        if (!Number.isSafeInteger(orderSeq) || orderSeq < 1) throw new Error('정산서 없음');
        Navigate(`/bill/${orderSeq}`);
      })
      .catch(() => setReviewCheckoutError('주문은 접수되었습니다. 정산서를 다시 열어주세요.'));
  };


  const handleBuyClick = () => {
    if (hasProductExposure(data) && !showExposurePrice(data.exposure_price_mode)) return;
    if (exposureSoldOut && isProductWaiting(waitingGroups, data)) return;

    if (!isLogin) {

      setIsLoginNeededModalOpen(true);

      return;

    }

    if (!couponAccess.canPurchase(data.seq) || (!exposureSoldOut && !canPurchaseProduct(data))) return;
    openBuy();

  };





  const handleIntroClick = () => {
    if (showExposurePrice(data.exposure_price_mode)) openIntro();
  };

  const handleBuyClickInIntro = () => {
    if (!showExposurePrice(data.exposure_price_mode) || (exposureSoldOut && isProductWaiting(waitingGroups, data))) return;
    if (!isLogin) {
      setIsLoginNeededModalOpen(true);
      return;
    }
    if (!couponAccess.canPurchase(data.seq) || (!exposureSoldOut && !canPurchaseProduct(data))) return;
    setIntroModal(false);
    setBuyModal(true);
  };

  useEffect(() => {
    let active = true;
    set_Live_Info(undefined); setLiveError(""); setBlocked(false);
    const load = async () => {
      try {
        const token = await restoreSession();
        if (!active) return;
        setIsLogin(Boolean(token));
        const response = await axios.get(url.Communication_url.get_live_info, {
          params: { seq }, headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });
        if (!active) return;
        if (reviewMode && (!Boolean(response.data?.payment_review_enabled) || response.data?.live_status === '취소' || response.data?.payment_mode !== 'pg')) {
          setLiveError('현재 이용할 수 없는 심사용 방송입니다.');
          return;
        }
        set_Live_Info(response.data);
        if (token) {
          void api.post(url.Communication_url.live_user_ban_check, { seq: response.data.seq })
            .then(({ data: result }) => { if (active && result === 'y') setBlocked(true); })
            .catch(() => undefined);
        }
      } catch {
        if (active) setLiveError("방송 정보를 불러오지 못했습니다. 다시 시도해 주세요.");
      }
    };
    void load();
    return () => { active = false; };
  }, [seq, liveRetry, reviewMode]);

  const refreshLiveStatus = useCallback(async () => {
    try {
      const token = await restoreSession();
      const response = await axios.get(url.Communication_url.get_live_info, {
        params: { seq }, headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      set_Live_Info(current => {
        const next = response.data;
        if (!current || current.seq !== next?.seq) return current;
        if (current.live_status === next.live_status && current.live_title === next.live_title && current.live_limit === next.live_limit
            && current.live_start === next.live_start && current.live_finish === next.live_finish && current.start_dt === next.start_dt) return current;
        return { ...current, live_status: next.live_status, live_title: next.live_title, live_limit: next.live_limit,
          live_start: next.live_start, live_finish: next.live_finish, start_dt: next.start_dt };
      });
    } catch {
      // The player keeps playing even if this one status refresh fails.
    }
  }, [seq]);

  useEffect(() => {
    if (reviewMode || !['예약', '리허설', '방송중'].includes(live_info?.live_status || '')) return;
    const refresh = () => { if (!document.hidden) void refreshLiveStatus(); };
    const timer = window.setInterval(refresh, live_info?.live_status === '방송중' ? 15000 : 3000);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('online', refresh);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('online', refresh);
    };
  }, [live_info?.live_status, refreshLiveStatus, reviewMode]);

  useEffect(() => {
    const storeSeq = live_info?.store_seq;
    if (blocked || !isLogin || !storeSeq || live_info?.follow_yn === "y" || followPromptedStoreRef.current === storeSeq) return;
    let active = true;
    void userinfoReturn().then(user => {
      if (!active || !user?.userid) return;
      const key = `fanbird:hide-follow-prompt:${encodeURIComponent(user.userid)}:${storeSeq}`;
      followPromptedStoreRef.current = storeSeq;
      setFollowPreferenceKey(key);
      try { if (localStorage.getItem(key) === '1') return; } catch { /* Storage may be unavailable in private mode. */ }
      setDontShowFollow(false);
      setIsFollowPromptOpen(true);
    }).catch(() => undefined);
    return () => { active = false; };
  }, [isLogin, live_info?.store_seq, live_info?.follow_yn, blocked]);

  const closeFollowPrompt = () => {
    if (dontShowFollow && followPreferenceKey) {
      try { localStorage.setItem(followPreferenceKey, '1'); } catch { /* Dismiss this visit even without persistent storage. */ }
    }
    setIsFollowPromptOpen(false);
  };

  const confirmFollow = async () => {
    if (followRunning.current) return;
    const storeSeq = live_info?.store_seq;
    if (!storeSeq) {
      closeFollowPrompt();
      return;
    }

    followRunning.current = true;
    setFollowBusy(true);
    try {
      await api.post(url.Communication_url.store_follow, { store_seq: storeSeq });
      set_Live_Info(previous => previous ? { ...previous, follow_yn: "y" } : previous);
      void userinfoReturn().then(user => {
        if (user?.userid) pushGtmEvent(GTM_EVENTS.favoriteAdd, storeSeq, user.userid);
      }).catch(() => undefined);
    } catch (err: any) {
      if (err?.response?.data?.message === "중복") {
        set_Live_Info(previous => previous ? { ...previous, follow_yn: "y" } : previous);
      }
    } finally {
      followRunning.current = false;
      setFollowBusy(false);
      closeFollowPrompt();
    }
  };

  useEffect(() => {

    // if (!state) {

    //   go_home();

    //   return;

    // }

    // 우클릭 금지

    const originalOnContextMenu = document.oncontextmenu;

    document.oncontextmenu = function () {
      return false;
    };


    return () => {

      document.oncontextmenu = originalOnContextMenu;

    };

  }, []);



  const chatRef = useRef<ChatComponentRef>(null); // Ref 타입을 명시



  const handleSendMessage = async () => {
    if (!isLogin) {

      setIsLoginNeededModalOpen(true);

      return;

    }

    if (chatRef.current) {

      if (mesage.length <= 100) {

        const sentText = mesage;
        const sent = await chatRef.current.sendMessage();
        if (sent) set_Mesage(current => current === sentText ? "" : current);
      } else {

        alert("입력 가능한 글자 수는 최대 100자입니다.");

      }

    }

  };



  // 볼륨조절

  const [volume, setVolume] = useState<number>(100); // 초기 볼륨 값

  const [volume_on, set_Volume_On] = useState<boolean>(false);

  const Volume_OnOff = () => set_Volume_On(!volume_on);



  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>

    setVolume(Number(event.target.value));



  const get_live_notice = useCallback(() => {
    (['ln', 'rn'] as const).forEach(type => {
      const request = ++noticeRequestRef.current[type];
      void axios.get(url.Communication_url.get_live_notice, { params: { seq, type }, timeout: 10000 })
        .then(({ data: notices }) => {
          if (request !== noticeRequestRef.current[type] || !Array.isArray(notices)) return;
          if (type === 'ln') set_Live_Notice(notices.find(notice => hasNoticeContent(notice.content)));
          else {
            const hasNotices = notices.some(notice => hasNoticeContent(notice.content));
            setHasRegularNotices(hasNotices);
            if (!hasNotices) setNoticeModal(false);
          }
        }).catch(() => { /* Keep the last confirmed notices during connection failures. */ });
    });
  }, [seq]);

  const noticesEnabled = Boolean(live_info && (reviewMode || live_info.live_status !== '종료'));
  useEffect(() => {
    set_Live_Notice(undefined);
    setHasRegularNotices(false);
    setNoticeModal(false);
    if (!noticesEnabled || !seq || seq === 'undefined') return;
    get_live_notice();
    // Regular notices have no socket event; refresh while the viewer is watching.
    const refresh = () => { if (!document.hidden) get_live_notice(); };
    const timer = window.setInterval(refresh, 30000);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('online', refresh);
    return () => {
      noticeRequestRef.current.ln += 1;
      noticeRequestRef.current.rn += 1;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('online', refresh);
    };
  }, [seq, get_live_notice, noticesEnabled]);

  // 소켓

  const [socket, setSocket] = useState<Socket | null>(null);



  useEffect(() => {

    if (seq === "undefined") {

      alert("방송정보가 없습니다.");

      Navigate("/", { replace: true });

    }

    if (live_info?.live_status === "예약") {
      set_Live_Time("00:00:00");
      set_Viewer_Count(0);
    }
    if (!blocked && live_info && ["방송중", "리허설"].includes(live_info.live_status)) {

      // 상품 노출은 IVS Timed Metadata가 도착할 때만 반영한다.
      // 소켓 연결을 초기화합니다.

      let active = true;
      const newSocket = io(SOCKET_SERVER_URL, {

        path: "/socket.io", // nginx에서 location /live/로 프록시 중이므로 필요

        transports: ["websocket"], // polling을 비활성화하고 WebSocket만 사용

      });

      setSocket(newSocket);



      newSocket.on("connect", () => {
        newSocket.emit("join-channel", { channelId: live_info?.channel_name });
        newSocket.emit("join-viewer", { channelId: live_info?.channel_name });
        setInventorySyncVersion(version => version + 1);
        if (isLogin) { void refreshTickets(); setCouponLetterRevision(current => current + 1); setOrderRevision(current => current + 1); }
      });


      // Coalesce a batch of product edits without changing the video-timed spotlight.
      let productListRefreshTimer: ReturnType<typeof setTimeout> | undefined;
      newSocket.on("Live Q&A Updated", (update: { liveSeq: number }) => qaUpdated(update.liveSeq));
      newSocket.on("Product List Changed", (update: { liveSeq: number }) => {
        if (update?.liveSeq !== live_info.seq) return;
        clearTimeout(productListRefreshTimer);
        productListRefreshTimer = setTimeout(() => {
          setProductListSyncVersion(version => version + 1);
          setOrderRevision(version => version + 1);
          if (isLogin) void refreshTickets();
        }, 250);
      });

      // 메시지를 수신할 때마다 state를 업데이트합니다.

      newSocket.on("Inventory Changed", (inventory: InventoryUpdate) => {
        if (!inventory || !Number.isSafeInteger(inventory.productSeq) || !Number.isFinite(inventory.currentCnt)) return;
        inventoryRevision.current += 1;
        latestStock.current.set(inventory.productSeq, inventory.currentCnt);
        setInventoryUpdate(inventory);
        set_Data(previous => previous.seq === inventory.productSeq
          ? { ...previous, current_cnt: inventory.currentCnt } : previous);
      });

      newSocket.on("Discount Coupon Updated", (update: { liveSeq?: number }) => {
        if (Number(update.liveSeq) === Number(seq)) setInventorySyncVersion(value => value + 1);
      });
      newSocket.on("Cancel Ticket Updated", (update: { userSeq?: number; ticketCount?: number; ticketCountAdded?: number }) => {
        if (!isLogin || !update) return;
        if (update.userSeq === currentUserSeqRef.current || currentUserSeqRef.current === null) setCouponLetterRevision(current => current + 1);
        if (update.userSeq !== undefined) {
          if (currentUserSeqRef.current === null) { void refreshTickets(); return; }
          if (update.userSeq === currentUserSeqRef.current && Number.isSafeInteger(update.ticketCount)) {
            ticketRequestRef.current += 1;
            setTicketCount(update.ticketCount!);
          }
        } else if (Number.isSafeInteger(update.ticketCountAdded) && update.ticketCountAdded! > 0) {
          // The grant used an earlier online snapshot; late arrivals must read their own balance.
          void refreshTickets();
        }
      });

      newSocket.on("Duration Time", (item: string) => {

        // console.log("Duration Time : ", item);

        set_Live_Time(item);

      });

      newSocket.on("Viewer Count", (item: string) => {
        // console.log("Viewer Count : ", item);

        set_Viewer_Count(Number(item));
      });
      newSocket.on("Live Notice", (item: live_notice_type[]) => {

        // console.log("Live Notice : ", item);

        noticeRequestRef.current.ln += 1;
        set_Live_Notice(Array.isArray(item) ? item.find(notice => hasNoticeContent(notice.content)) : undefined);
      });

      // 방송과 리허설 모두 상품 팝업은 영상 메타데이터와 재생 지연 기준으로 반영합니다.
      const Blocked_Id = async () => {

        try {

          const userinfo = await userinfoReturn();

          if (active && userinfo && userinfo.userid) {

            currentUserSeqRef.current = Number((userinfo as typeof userinfo & { seq?: number }).seq) || null;
            setViewerNickname(userinfo.nickname || '');
            newSocket.on("Blocked Id", (item: string) => {

              // console.log(item);

              item === userinfo.userid && setBlocked(true);
            });

          }

        } catch (e) {

          console.log("비회원 시청자 (로그인 정보 없음)");

        }

      };

      if (isLogin) Blocked_Id();




      // 컴포넌트가 언마운트될 때 소켓 연결을 정리합니다.

      return () => {

        active = false;
        clearTimeout(productListRefreshTimer);
        newSocket.disconnect();

      };

    }

  }, [live_info?.seq, live_info?.channel_name, live_info?.live_status, isLogin, blocked]);



  useEffect(() => {
    if (!reviewMode || !live_info?.payment_review_enabled) return;
    let active = true;
    axios.get(url.Communication_url.product_list, { params: { live_seq: live_info.seq } })
      .then(({ data: products }) => {
        if (!active || !Array.isArray(products)) return;
        const selling = products.filter((product: props_data_type) => canPurchaseProduct(product));
        const featured = selling.find((product: props_data_type) => product.current_cnt > 0) || selling[0];
        if (featured) set_Data({ ...featured, exposure_active: true });
      }).catch(() => undefined);
    const started = Date.now();
    const timer = window.setInterval(() => {
      const seconds = Math.floor((Date.now() - started) / 1000);
      const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor(seconds / 60 % 60).toString().padStart(2, '0');
      const remainder = (seconds % 60).toString().padStart(2, '0');
      set_Live_Time(`${hours}:${minutes}:${remainder}`);
    }, 1000);
    return () => { active = false; window.clearInterval(timer); };
  }, [reviewMode, live_info?.seq, live_info?.payment_review_enabled]);

  useEffect(() => {
    if (reviewMode || !live_info || !['방송중', '리허설'].includes(live_info.live_status)) return;
    const startedAt = parseLiveClosingTime(live_info.start_dt);
    if (startedAt === null) return;
    const update = () => {
      const seconds = Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
      set_Live_Time([Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
        .map(value => String(value).padStart(2, '0')).join(':'));
    };
    update();
    const timer = window.setInterval(update, 1000);
    return () => window.clearInterval(timer);
  }, [reviewMode, live_info?.start_dt, live_info?.live_status]);

  // const closingAt = parseLiveClosingTime(live_info?.live_finish); // 종료 타이머 비활성화
  const isCommerceLive = Boolean(live_info && (reviewMode || ["방송중", "리허설"].includes(live_info.live_status)));
  const isChatLive = isCommerceLive;
  const exposureSoldOut = getProductSaleStatus(data.product_status) === "품절" || data.current_cnt <= 0;
  const canWaitForExposure = exposureSoldOut && !reviewMode && live_info?.live_status === '방송중';
  const showProductPopup = isChatLive && hasProductExposure(data);
  const showProductPrice = showExposurePrice(data.exposure_price_mode);
  const linkedPurchase = couponAccess.isLinkedProduct(data.seq);
  const hideControlsOnBackgroundClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!(event.target as HTMLElement).closest('button, input, textarea, a, [data-live-action]')) {
      set_All_Visible(false);
    }
  };

  useEffect(() => {
    if (reviewMode || !live_info || live_info.integration_test || live_info.live_status === '리허설' || !data.seq || !showProductPopup) return;
    const target = document.querySelector(`[data-analytics-product="${data.seq}"]`);
    if (!target || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { trackLiveEvent('product_exposure', live_info.seq, data.seq); observer.disconnect(); }
    }, { threshold: 0.5 });
    observer.observe(target); return () => observer.disconnect();
  }, [live_info?.seq, live_info?.live_status, data.seq, showProductPopup, reviewMode]);

  if (blocked && live_info) {
    return <Layout_user><Block visible handleModal={() => {}} storeSeq={live_info.store_seq}
      ban_popup="이 셀러의 라이브 이용이 제한되었습니다. 자세한 내용은 해당 셀러에게 문의해주세요." /></Layout_user>;
  }

  if (!liveError && live_info && !reviewMode && !live_info.integration_test && live_info.live_status === "종료"
      && playedLiveRef.current !== live_info.seq) {
    return <Layout_user><EndedLive title={live_info.live_title} storeName={live_info.store_name} onBrowse={go_home} /></Layout_user>;
  }

  if (liveError || !live_info) {
    return <Layout_user><StatePage label="라이브" icon="live" kind={liveError ? "error" : "loading"}
      title={liveError || "방송 정보를 불러오고 있습니다."}
      description={liveError ? "연결 상태를 확인하거나 다른 라이브를 둘러보세요." : "잠시만 기다려 주세요. 라이브에 연결하고 있어요."}
      action={liveError ? { label: "다시 시도", onClick: () => setLiveRetry(value => value + 1) } : undefined}
      secondaryAction={liveError ? { label: "라이브 목록으로", onClick: go_home } : undefined} /></Layout_user>;
  }
  return (

    <Layout_user isScroll="none">

      <Box translate="no">

        <Streaming_Box>

          {reviewMode ? <ReviewBlackPlayer allVisible={all_visible} onVisibilityChange={set_All_Visible} /> : <Live_Component
              ref={livePlayerRef}
                onMutedChange={muted => {
                  setPlaybackMuted(muted);
                  if (!muted) setIsMuted(false);
                }}
                volume={isMuted ? 0 : volume}
              isAuthenticated={isLogin}
              integrationHostState={integrationHostState}
              set_All_Visible={set_All_Visible}

              all_visible={all_visible}

              live_info={live_info}

              onPlaybackStarted={(latencySeconds, playbackTime) => {
                playedLiveRef.current = live_info.seq;
                void refreshLiveStatus();
                exposure.onPlaybackStarted(latencySeconds, playbackTime);
              }}


              onPlaybackPaused={exposure.onPlaybackPaused}
              on_product_metadata={(_action, item, publishedAt) => exposure.onMetadata(item, publishedAt)}
            />}
          {all_visible && (

            <>

              <Status_Box onClick={hideControlsOnBackgroundClick}>
                <div style={{ display: "flex" }}>

                  <LiveStatusBadge status={live_info?.live_status === "예약" ? "준비" : live_info?.live_status} />
                  <Time_Box>

                    <Shadow_Icon

                      src={require("../../../Image/ic_time_white.png")}

                    />

                    &nbsp;{live_time}

                  </Time_Box>

                  <Viewer_Count_Box>

                    <Shadow_Icon

                      src={require("../../../Image/ic_viewer_white.png")}

                    />

                    &nbsp;{viewer_count}

                  </Viewer_Count_Box>

                </div>

                <div style={{ display: "flex", alignItems: "center" }}>


                  <Mute_Btn data-live-action
                    aria-label={isMuted || playbackMuted ? "소리 켜기" : "소리 끄기"}
                    onClick={() => {
                      if (isMuted || playbackMuted) {
                        setIsMuted(false);
                        livePlayerRef.current?.unmute(volume);
                      } else setIsMuted(true);
                    }}
                  >
                    <Icon src={(isMuted || playbackMuted) ? require("../../../Image/ic_mute_on.png") : require("../../../Image/ic_mute_off.png")} alt="" />
                  </Mute_Btn>


                  <Exit_Btn type="button" aria-label="라이브 나가기" data-live-action
                    onClick={() => { if (isLogin && !reviewMode && live_info.live_status === '방송중') exitGuard.requestExit(); else go_home(); }}>
                    <Icon src={require("../../../Image/ic_x_white2.png")} alt="" />
                  </Exit_Btn>
                </div>

              </Status_Box>

              <Title_Box onClick={hideControlsOnBackgroundClick}>
                <Title>
                  <ScrollingLiveTitle title={live_info?.live_title || ""} />
                </Title>

                <TicketContainer>

                  {isLogin && ticketCount > 0 && <TicketBox type="button" aria-label={`보유 취소 쿠폰 ${ticketCount}장`} aria-expanded={isTooltipOpen} data-live-action onClick={() => setIsTooltipOpen(!isTooltipOpen)}>
                    <Icon

                      src={ticketIcon}
                      alt=""
                      style={{ width: 18, height: 18 }}
                    />

                    <TicketNum>{ticketCount}</TicketNum>

                  </TicketBox>}
                  {isLogin && ticketCount > 0 && isTooltipOpen && (
                    <Tooltip>

                      <TooltipText>주문 취소할 수 있는 티켓입니다.</TooltipText>

                      <TooltipClose type="button" aria-label="취소 쿠폰 안내 닫기" data-live-action onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.stopPropagation();

                        setIsTooltipOpen(false);

                      }}>×</TooltipClose>

                    </Tooltip>

                  )}


                  {reviewCheckoutError && <ReviewCheckoutAlert role="alert">
                    {reviewCheckoutError}
                    <button type="button" onClick={completeReviewPurchase}>정산서 다시 열기</button>
                  </ReviewCheckoutAlert>}

                </TicketContainer>
              </Title_Box>

              {live_notice && hasNoticeContent(live_notice.content) && (
                <Notice role="note" aria-label="라이브 공지" data-live-action><ExpandableNotice content={live_notice.content} html previewLength={15} consumeOutsideClick /></Notice>
              )}
              <Purchase_Notice_Anchor>
                <ViewerPurchaseNotices notices={purchaseNotices} celebration={celebration} viewerNickname={viewerNickname} urgentNotice={Boolean(live_notice && hasNoticeContent(live_notice.content))} />
              </Purchase_Notice_Anchor>
              {volume_on && (

                <Volume_Box>

                  <Volume

                    min="0"

                    max="100"

                    value={volume}

                    onChange={handleChange}

                  />

                </Volume_Box>

              )}

            </>

          )}

          {isChatLive && (
            <Bottom_Box $visible={all_visible} aria-hidden={!all_visible} onClick={hideControlsOnBackgroundClick}>
              <Bottom_Row>

                <Item_Chat_Box>

                  {all_visible && hasQa && <QaButton type="button" data-live-action aria-haspopup="dialog" onClick={() => setQaOpen(true)}>Q&A</QaButton>}
                  <Chat_Box aria-label="라이브 채팅 메시지"
                    style={{

                      height:

                        showProductPopup ? 150 : 220,

                      maxHeight:

                        showProductPopup ? 150 : 220,

                    }}

                  >

                    <ChatComponent

                        ref={chatRef}

                        mesage={mesage}

                        all_visible={all_visible}

                        live_info={live_info!}
                        isAuthenticated={isLogin}
                        onPurchaseNotification={showPurchaseNotification}
                      />

                  </Chat_Box>

                  {(showProductPopup || (purchaseSuccess.active && data.seq > 0)) && (
                    <Item_Box ref={purchaseSuccess.cardRef} translate="no" data-analytics-product={data.seq}>
                      <Item_Summary>
                      <Item_Thumb_Wrapper as="button" type="button" aria-label={`${data.name} 이미지 확대 보기`} data-live-action
                        disabled={!productImages[0] && !data.thumbnail_img} onClick={() => setImageViewerOpen(true)} style={{ cursor: 'zoom-in', padding: 0, border: 0 }}>
                        <Item_ThumbImg
                          src={productImages[0] || mediaUrl(data.thumbnail_img)}
                          alt={data.name}
                        />
                      </Item_Thumb_Wrapper>



                      <Item_Mid_Box data-live-action onClick={isCommerceLive && showProductPrice ? handleIntroClick : undefined} style={{ cursor: isCommerceLive && showProductPrice ? "pointer" : "default" }}>
                        <Item_Name>{data.name}</Item_Name>

                        {showProductPrice && <Item_Price>{amountFormat(couponAccess.priceFor(data.seq, Number(data.price)))}원</Item_Price>}
                      </Item_Mid_Box>
                      </Item_Summary>
                      {couponAccess.error && <p role="alert">{couponAccess.error}</p>}
                      <ViewerProductStock key={data.seq} product={data} inventoryUpdate={inventoryUpdate} revision={inventorySyncVersion} />
                      {(showProductPrice || exposureSoldOut) && <Product_Actions>
                      {showProductPrice && <Buy_Btn
                        as="button"

                        disabled={couponAccess.loading || Boolean(couponAccess.error) || !couponAccess.canPurchase(data.seq) || !isCommerceLive || (exposureSoldOut && (!canWaitForExposure || isProductWaiting(waitingGroups, data))) || !showProductPopup}
                        data-waiting={exposureSoldOut && hasProductWaiting(waitingGroups, data) || undefined}
                        ref={purchaseSuccess.buttonRef}
                        $success={purchaseSuccess.successId > 0}
                        onClick={handleBuyClick}

                        translate="no"

                      >

                        <PurchaseSuccessLabel successId={purchaseSuccess.successId} label={<>{exposureSoldOut && canWaitForExposure && <WaitBellIcon />}{exposureSoldOut ? canWaitForExposure ? hasProductWaiting(waitingGroups, data) ? "대기 중" : "대기" : "품절" : linkedPurchase ? "연계 구매 상품" : "구매"}</>} />
                      </Buy_Btn>}
                      </Product_Actions>}
                    </Item_Box>

                  )}

                </Item_Chat_Box>

                {all_visible && (

                  <Side_Btn_Box>
                    {/* 종료 타이머 비활성화: (!reviewMode || (process.env.NODE_ENV !== "production" && document.querySelector('meta[name="fanbird-local-review"]'))) && live_info?.live_status === "방송중" && closingAt !== null && <LiveClosingCountdown endsAt={closingAt} /> */}
                    {hasRegularNotices && <Side_Action type="button" onClick={openNotice}>
                      <Side_Btn_Wrapper><Side_Btn alt="" src={require("../../../Image/ic_notice.png")} /></Side_Btn_Wrapper>
                      <Side_Btn_Label>공지사항</Side_Btn_Label>
                    </Side_Action>}


                    {isCommerceLive && <Side_Action type="button" onClick={openDeliveryInfo}>
                      <Side_Btn_Wrapper><Side_Btn alt="" src={require("../../../Image/ic_info.png")} /></Side_Btn_Wrapper>
                      <Side_Btn_Label>구매 목록</Side_Btn_Label>
                    </Side_Action>}

                    {isCommerceLive && <Side_Action type="button" onClick={openItemList}>
                      <Side_Btn_Wrapper><Side_Btn alt="" src={require("../../../Image/ic_list.png")} /></Side_Btn_Wrapper>
                      <Side_Btn_Label>상품목록</Side_Btn_Label>
                    </Side_Action>}
                  </Side_Btn_Box>

                )}

              </Bottom_Row>

              {all_visible && (

                <Chat_Insert_Box>

                  <Chat_Insert>

                    <Insert_Text

                      value={mesage}
                      rows={Math.min(3, mesage.split('\n').length)}
                      maxLength={100}
                      enterKeyHint="send"

                      placeholder="메시지를 입력해주세요."

                      onChange={(e) => set_Mesage(e.target.value)}

                      onFocus={(e) => {

                        if (!isLogin) {

                          e.target.blur();

                          setIsLoginNeededModalOpen(true);

                        }

                      }}

                      onKeyDown={event => handleChatComposerKeyDown(event, set_Mesage, () => { void handleSendMessage(); })}

                    />



                    <Send_Icon data-live-action
                      src={require("../../../Image/ic_send_white.png")}

                      onClick={handleSendMessage}

                    />

                  </Chat_Insert>

                </Chat_Insert_Box>

              )}

            </Bottom_Box>

          )}



          <PurchaseEffectsLayer ref={purchaseSuccess.layerRef} hidden={!all_visible} data-effect={purchaseSuccess.effect} />
          <RestockWaitPanel liveSeq={Number(seq)} enabled={!!isLogin && !reviewMode && live_info?.live_status === '방송중'} onConfirmed={completeLivePurchase} onWaitingChange={setWaitingGroups} />
          <Buy_Modal

            visible={BuyModal}

            handleModal={setBuyModal}

            couponAccess={couponAccess}
            item={data}

            seq={Number(seq)}
            type="live"
            sellerId={live_info?.store_seq}
            imageUrl={productImages[0]}
            onPurchaseComplete={reviewMode ? completeReviewPurchase : completeLivePurchase}
            onOrderConfirmed={onOrderConfirmed}
            inventoryUpdate={inventoryUpdate}
            canWait={!!isLogin && !reviewMode && live_info?.live_status === '방송중'}
            inventorySyncVersion={inventorySyncVersion}
            waitingGroups={waitingGroups}
            onWaitJoined={onWaitJoined}
          />

          <Product_Intro_Modal
            visible={IntroModal && showProductPrice}
            handleModal={setIntroModal}
            refreshVersion={productInfoSyncVersion}
            couponAccess={couponAccess}
            item={data}
            isWaiting={exposureSoldOut && isProductWaiting(waitingGroups, data)}
            onBuyClick={handleBuyClickInIntro}
          />

          <Notice_Modal

            visible={NoticeModal}

            handleModal={setNoticeModal}

            seq={Number(seq)}

          />

          <CancelTicketLetter liveSeq={Number(seq)} enabled={isLogin} revision={couponLetterRevision} />
          <LiveQaModal visible={qaOpen} onClose={() => setQaOpen(false)} liveSeq={Number(seq)} isAuthenticated={isLogin}
            onLoginRequired={() => { setQaOpen(false); setIsLoginNeededModalOpen(true); }} />
          <Delivery_Info_Modal

            visible={DeliveryInfoModal}

            handleModal={setDeliveryInfoModal}

            seq={Number(seq)}

            ticketCount={ticketCount}

            canCancel={['방송중', '리허설'].includes(live_info.live_status)}

            onOrderChanged={refreshTickets}

            refreshKey={orderRevision}
          />

          <Item_List_Modal
            couponAccess={couponAccess}
            visible={ItemListModal}

            handleModal={setItemListModal}

            seq={Number(seq)}
            sellerId={live_info?.store_seq}
            canWait={!!isLogin && !reviewMode && live_info?.live_status === '방송중'}
            isAuthenticated={isLogin}
            onLoginRequired={() => setIsLoginNeededModalOpen(true)}
            onPurchaseComplete={reviewMode ? completeReviewPurchase : completeLivePurchase}
            onOrderConfirmed={onOrderConfirmed}
            inventoryUpdate={inventoryUpdate}
            inventorySyncVersion={inventorySyncVersion}
            waitingGroups={waitingGroups}
            onWaitJoined={onWaitJoined}
            productListSyncVersion={productListSyncVersion}
          />


        </Streaming_Box>

      </Box>

      {exitModalOpen && <LiveExitModal liveSeq={Number(seq)} onClose={() => { exitGuard.cancelExit(); setExitModalOpen(false); }}
        onLeave={() => exitGuard.confirmExit(go_home)} onCheckout={orderSeq => exitGuard.navigateAway(() => Navigate(`/bill/${orderSeq}`))} />}
      {imageViewerOpen && <ProductImageViewer name={data.name} images={productImages.length ? productImages : [mediaUrl(data.thumbnail_img)]} onClose={() => setImageViewerOpen(false)} />}
      {isFollowPromptOpen && !blocked && (
        <AlertOverlay onClick={closeFollowPrompt}>
          <AlertBox role="dialog" aria-modal="true" aria-label={`${live_info?.store_name || "셀러"} 팔로우`} onClick={(e) => e.stopPropagation()}
            onKeyDown={event => { if (event.key === "Escape") { event.preventDefault(); closeFollowPrompt(); } }}>
            <AlertTitle style={{ marginBottom: 8 }}>
              {live_info?.store_name || "셀러"} 팔로우
            </AlertTitle>
            <AlertText style={{ marginBottom: 20 }}>
              {`${live_info?.store_name || "셀러"}를 팔로우 하시겠습니까?\n\n팔로우 하면 방송 소식을 받아볼 수 있어요`}
            </AlertText>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, minHeight: 44, marginBottom: 12, cursor: 'pointer' }}>
              <input type="checkbox" checked={dontShowFollow} onChange={event => setDontShowFollow(event.target.checked)} />다시 보지 않기
            </label>
            <AlertButtonRow>
              <AlertCancelBtn autoFocus onClick={closeFollowPrompt}>
                취소
              </AlertCancelBtn>
              <FollowConfirmBtn disabled={followBusy} aria-busy={followBusy} onClick={confirmFollow}>
                확인
              </FollowConfirmBtn>
            </AlertButtonRow>
          </AlertBox>
        </AlertOverlay>
      )}

      {/* 비회원 로그인 유도 모달 */}
      {isLoginNeededModalOpen && (
        <AlertOverlay onClick={() => setIsLoginNeededModalOpen(false)}>
          <AlertBox onClick={(e) => e.stopPropagation()}>

            <AlertTitle style={{ marginBottom: 8 }}>로그인</AlertTitle>

            {reviewMode ? <>
              <AlertText style={{ marginBottom: 16 }}>로그인 후 상품을 구매하고 정산서에서 결제할 수 있습니다.</AlertText>
              <ReviewLoginForm onSubmit={reviewLogin}>
                <label htmlFor="review-userid">아이디</label>
                <input id="review-userid" autoComplete="username" value={reviewUserid} onChange={event => setReviewUserid(event.target.value)} required disabled={reviewLoginBusy} />
                <label htmlFor="review-password">비밀번호</label>
                <input id="review-password" type="password" autoComplete="current-password" value={reviewPassword} onChange={event => setReviewPassword(event.target.value)} required disabled={reviewLoginBusy} />
                {reviewLoginError && <span role="alert">{reviewLoginError}</span>}
                <button type="submit" disabled={reviewLoginBusy}>{reviewLoginBusy ? '로그인 중…' : '로그인'}</button>
              </ReviewLoginForm>
              <AlertButtonRow>
                <AlertCancelBtn onClick={() => setIsLoginNeededModalOpen(false)}>취소</AlertCancelBtn>
                <KakaoLoginBtn onClick={goKaKaoLogin}>카카오 로그인</KakaoLoginBtn>
              </AlertButtonRow>
            </> : <>
              <AlertText style={{ marginBottom: 20 }}>
                로그인 후, 이용하실 수 있어요.{"\n"}
                로그인하고 특가 상품을 득템해 보세요!
              </AlertText>
              <AlertButtonRow>
                <AlertCancelBtn onClick={() => setIsLoginNeededModalOpen(false)}>취소</AlertCancelBtn>
                <KakaoLoginBtn onClick={goKaKaoLogin}>카카오 로그인</KakaoLoginBtn>
              </AlertButtonRow>
            </>}
          </AlertBox>

        </AlertOverlay>

      )}

    </Layout_user>

  );

};



export default Live;



const Box = styled.div`
  color: white;
  background-color: black;

  background-size: contain;

  height: 100%;

  display: flex;

  align-items: center;

`;



const Streaming_Box = styled.div`

  width: 100%;

  height: 100%;

  min-height: 0;
  /* background-color: #de9c9c; */

  position: relative;

  display: flex;

  flex-direction: column;

  overflow: hidden;

`;



const Title_Box = styled.div`

  position: relative;
  width: 100%;

  align-items: flex-start;
  display: flex;

  flex-direction: row;

  justify-content: space-between;

  z-index: 1;

  padding: 20px 0px 14px 0px;
`;



const Title = styled.div`
  flex: 1;
  min-width: 0;

  ${fontStyles.Bold};

  font-size: 20px;

  margin-left: 16px;

  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가

  white-space: nowrap;

  overflow: hidden; /* 텍스트가 박스를 넘지 않도록 설정 */

  position: relative; /* 내부 span의 위치를 기준으로 설정 */

`;



const Exit_Btn = styled.button`
  display: inline-grid;
  place-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  img { width: 24px; height: 24px; }
  &:focus-visible { outline: 2px solid white; outline-offset: 2px; }
  cursor: pointer;

  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;

  -webkit-user-drag: none;

  -khtml-user-drag: none;

  -moz-user-drag: none;

  -o-user-drag: none;

  &:active {

    opacity: 0.5; // 클릭 시 opacity 변화

  }

`;



const Status_Box = styled.div`

  z-index: 1;

  width: 100%;

  padding: calc(16px + env(safe-area-inset-top)) 16px 0px 16px;
  display: flex;

  align-items: center;

  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;

  -webkit-user-drag: none;

  -khtml-user-drag: none;

  -moz-user-drag: none;

  -o-user-drag: none;

  box-sizing: border-box;

  justify-content: space-between;

`;



const Time_Box = styled.div`

  margin-left: 8px;

  display: flex;

  font-family: var(--font-Pretendard-SemiBold);

  color: white;

  align-items: center;

  font-size: 16;

  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가

`;



const Viewer_Count_Box = styled.div`

  margin-left: 16px;

  display: flex;

  font-family: var(--font-Pretendard-SemiBold);

  color: white;

  align-items: center;

  font-size: 16;

  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가

`;



const Shadow_Icon = styled(Icon)`

  filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.5)); /* 그림자 적용 */

`;



const Purchase_Notice_Anchor = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  flex-shrink: 0;
  z-index: 60; /* Purchase alerts stay above camera / mic OFF status (55). */
`;

const Notice = styled.div`
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  z-index: 2;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 0 16px 8px;
  font-size: 14px;
  width: fit-content;
  min-width: 0;
  max-width: calc(100% - 32px);
  background-color: var(--user-surface);
  border: 1px solid var(--user-border);
  color: var(--user-text);
`;



const QaButton = styled.button`
  display: flex; align-items: center; align-self: flex-start; gap: 8px; min-height: 44px;
  margin-block: 8px; padding: 8px 12px; border: 1px solid var(--user-border);
  border-radius: 999px; background: var(--user-surface); color: var(--user-text); font-family: var(--font-Pretendard-Regular); font-size: 15px; font-weight: 600; cursor: pointer;
`;
const Bottom_Box = styled.div<{ $visible: boolean }>`
  min-height: 0;
  display: ${({ $visible }) => ($visible ? "flex" : "none")};
  width: 100%;

  /* background-color: #a9a9a9; */

  height: clamp(370px, 48dvh, 450px);
  flex-shrink: 0;
  margin-top: auto;

  flex-direction: column;

  position: relative;

  padding: 15px 0 0 0;

  box-sizing: border-box;

  z-index: 1;

`;



const Chat_Insert_Box = styled.div`
  flex-shrink: 0;
  align-self: flex-end;

  min-height: calc(50px + env(safe-area-inset-bottom));
  width: 100%;

  align-items: center;

  justify-content: center;

  margin-top: auto;

`;



const Chat_Insert = styled.div`

  width: 100%;

  min-height: calc(50px + env(safe-area-inset-bottom));

  background-color: rgba(20, 20, 20, 0.85);

  padding: 0px 20px env(safe-area-inset-bottom);
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  align-items: center;

  display: flex;

  position: relative;

  box-sizing: border-box;

  justify-content: space-between;

`;



const Bottom_Row = styled(RowView)`
  flex: 1;
  margin-bottom: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  width: 100%;
  align-items: flex-end;
  min-height: 0;
`;


const Item_Chat_Box = styled.div`
  min-width: 0;
  display: flex;

  height: 100%;

  flex: 1;

  flex-direction: column;

  margin-right: 18px;

  align-items: center;

  justify-content: flex-end;

  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;

  -webkit-user-drag: none;

  -khtml-user-drag: none;

  -moz-user-drag: none;

  -o-user-drag: none;

  box-sizing: border-box;

`;



const Chat_Box = styled.div`
  width: 100%;
  max-width: 100%;
  /* height: 150px;

  max-height: 150px; */

  flex: 1;

  display: flex;
  position: relative;
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
`;


const Item_Box = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin-top: 14px;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 10px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,.16);
  background: rgba(17,20,32,.86);
  backdrop-filter: blur(12px);
  padding: 10px;
`;

const Item_Summary = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
`;

const Item_Thumb_Wrapper = styled.div`

  position: relative;

  width: 48px;
  height: 48px;
  border-radius: 6px;

  overflow: hidden;

  flex-shrink: 0;

`;



const Item_ThumbImg = styled(ProductThumbnail)`
  width: 100%;

  height: 100%;

  object-fit: cover;

`;





const Item_Mid_Box = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;

  flex-direction: column;

  justify-content: center;

  gap: 6px;

  padding: 0 12px;

  box-sizing: border-box;

`;



const Item_Name = styled.div`
  font-size: 13px;
  color: #fff;
  font-family: var(--font-Pretendard-Bold);

  display: -webkit-box;

  -webkit-line-clamp: 1;

  -webkit-box-orient: vertical;

  overflow: hidden;

`;



const Item_Price = styled.div`

  font-size: 16px;

  color: #fff;
  font-family: var(--font-Pretendard-Bold);

`;



const Buy_Btn = styled.button<BuyBtnProps>`
  width: 100%;
  min-height: 44px;
  border: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: white;
  background: linear-gradient(100deg, #7955f0, #6332cf);
  font-size: 14px;
  font-family: var(--font-Pretendard-Bold);
  cursor: pointer;
  transition: background 180ms ease, opacity 180ms ease;
  &:disabled { background: #374151; color: #d1d5db; cursor: not-allowed; }
  &[data-waiting] { background: #374151; color: #d1d5db; }
  &:active:not(:disabled) { opacity: .8; }
  &:focus-visible { outline: 2px solid white; outline-offset: 3px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
  ${purchaseSuccessButtonStyles}
`;

const Product_Actions = styled.div`
  display: flex; align-items: stretch; gap: 8px;
  > * { flex: 1; min-width: 0; }
`;

const Mute_Btn = styled.button.attrs({ type: "button" })`
  display: inline-flex; align-items: center; justify-content: center;
  appearance: none; padding: 7px; border: 0; background: transparent;
  width: 44px; height: 44px; margin-right: 6px; color: inherit; cursor: pointer;
  > img { width: 30px; height: 30px; }
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  &:active { opacity: 0.5; }
`;

/* 티켓 수 및 툴팁 스타일 */

const TicketContainer = styled.div`

  position: relative;

  margin-right: 16px;

  flex-shrink: 0;
  z-index: 10;

`;



const TicketBox = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 0;
  background-color: rgba(0, 0, 0, 0.6);

  border-radius: 8px;
  padding: 6px 8px;
  cursor: pointer;

  min-width: 52px;
  min-height: 32px;
  box-sizing: border-box;

  &::before { content: ""; position: absolute; inset: -6px 0; }
  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
  &:active {

    opacity: 0.8;

  }

`;



const TicketNum = styled.div`
  color: white;
  font-size: 12px;
  font-family: var(--font-Pretendard-Bold);
`;



const Tooltip = styled.div`

  position: absolute;

  top: 38px;

  right: 0;

  background-color: rgba(33, 33, 33, 0.95);

  color: white;

  border-radius: 8px;

  padding: 10px 16px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  white-space: nowrap;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);

  box-sizing: border-box;

  z-index: 20;

  animation: fadeIn 0.15s ease-out;



  &::after {

    content: "";

    position: absolute;

    top: -6px;

    right: 24px;

    border-width: 0 6px 6px 6px;

    border-style: solid;

    border-color: transparent transparent rgba(33, 33, 33, 0.95) transparent;

  }



  @keyframes fadeIn {

    from {

      opacity: 0;

      transform: translateY(-4px);

    }

    to {

      opacity: 1;

      transform: translateY(0);

    }

  }

`;



const TooltipText = styled.div`

  font-size: 12px;

  font-family: var(--font-Pretendard-Medium);

  line-height: 1.4;

`;



const TooltipClose = styled.button`
  display: inline-flex; align-items: center; justify-content: center;
  appearance: none; border: 0; background: transparent; min-width: 32px; min-height: 32px;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }

  cursor: pointer;

  font-size: 16px;

  color: var(--user-text-muted);
  padding: 4px;

  margin-left: 10px;

  &:hover {

    color: white;

  }

`;



const Side_Btn_Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-end;
  align-self: flex-end;
  flex-shrink: 0;
  height: auto;
  min-height: 206px;
  width: 60px;
  color: white;
`;


const Side_Action = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 0;
  background: transparent;
  padding: 0;
  margin-top: 18px;
  cursor: pointer;
`;

const Side_Btn_Wrapper = styled(CenterView)`
  width: 44px;

  height: 44px;

  border-radius: 50%;

  background-color: #1D1D1D;

  cursor: pointer;

  transition: background-color 0.15s ease;

  &:active {

    background-color: #333333;

  }

`;



const Side_Btn = styled(Icon)`

  width: 24px;

  height: 24px;

  object-fit: contain;

  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;

  -webkit-user-drag: none;

  -khtml-user-drag: none;

  -moz-user-drag: none;

  -o-user-drag: none;

`;



const Side_Btn_Label = styled.div`

  font-size: 11px;

  color: #E2E2E2;

  margin-top: 6px;

  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);

  font-family: var(--font-Pretendard-Medium);

  text-align: center;

  white-space: nowrap;

`;



const Volume_Box = styled.div`

  z-index: 10;

  background-color: var(--user-surface);
  position: absolute;

  display: flex;

  right: 15px;

  top: 25%;

  width: 35px;

  height: 250px;

  justify-content: center;

  align-items: center;

  border-radius: 100px;

`;



const Volume = styled.input.attrs({ type: "range" })<VolumeProps>`

  -webkit-appearance: none;

  display: flex;

  position: absolute;

  width: 220px;

  height: 8px;

  background: transparent;

  border-radius: 5px;

  outline: none;

  transform: rotate(270deg);

  writing-mode: bt-lr;



  &::-webkit-slider-thumb {

    -webkit-appearance: none;

    appearance: none;

    width: 20px;

    height: 20px;

    border-radius: 50%;

    background: #e4e4e4;

    border: 6px solid white;

    cursor: pointer;

    transform: translateY(-6px);

    box-shadow: 0 0px 5px rgba(0, 0, 0, 0.5);

  }



  &::-webkit-slider-runnable-track {

    width: 100%;

    height: 8px;

    cursor: pointer;

    background: linear-gradient(

      to right,

      var(--user-accent) ${(props) => props.value}%,
      var(--user-border) ${(props) => props.value}%
    );

    border-radius: 5px;

    position: relative;

  }

`;



const Send_Icon = styled(Shadow_Icon)`

  justify-self: flex-end;

  cursor: pointer;

  &:active {

    opacity: 0.5;

  }

`;



const Insert_Text = styled.textarea`
  resize: none;
  box-sizing: border-box;
  padding: 12px 0;
  line-height: 24px;
  font-family: inherit;

  outline: none;

  border: none;

  width: 100%;

  font-size: 16px;

  background-color: rgba(255, 255, 255, 0);

  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가

  color: white;

  &::placeholder {

    color: white;

  }

`;





const AlertOverlay = styled.div`

  position: fixed;

  inset: 0;

  background-color: rgba(0, 0, 0, 0.5);

  display: flex;

  align-items: center;

  justify-content: center;

  z-index: 100;

  padding: 24px;

`;



const AlertBox = styled.div`

  background-color: var(--user-surface);
  border-radius: 16px;

  width: 100%;

  max-width: 320px;

  padding: 24px;

  display: flex;

  flex-direction: column;

  align-items: center;

  box-sizing: border-box;

`;



const AlertTitle = styled.div`

  font-size: 18px;

  font-family: var(--font-Pretendard-Bold);

  color: var(--user-text);
  text-align: center;

`;



const AlertText = styled.div`

  font-size: 14px;

  color: var(--user-text);
  font-family: var(--font-Pretendard-Medium);

  line-height: 20px;

  text-align: center;

  white-space: pre-wrap;

`;



const AlertButtonRow = styled(RowView)`

  width: 100%;

  gap: 8px;

`;



const AlertCancelBtn = styled(CenterView).attrs({ as: "button", type: "button" })`
  appearance: none;
  border: 0;
  padding: 0;
  min-width: 0;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  &:disabled { opacity: .65; cursor: wait; }

  flex: 1;

  height: 48px;

  background-color: var(--user-surface-raised);
  color: var(--user-text-muted);
  font-family: var(--font-Pretendard-Bold);

  font-size: 15px;

  border-radius: 8px;

  cursor: pointer;

  user-select: none;

`;



const KakaoLoginBtn = styled(CenterView).attrs({ as: "button", type: "button" })`
  appearance: none;
  border: 0;
  padding: 0;
  min-width: 0;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  &:disabled { opacity: .65; cursor: wait; }
  flex: 1;
  height: 48px;
  background-color: #fee500;
  color: #191919;

  font-family: var(--font-Pretendard-Bold);

  font-size: 15px;

  border-radius: 8px;

  cursor: pointer;
  user-select: none;
`;

const FollowConfirmBtn = styled(CenterView).attrs({ as: "button", type: "button" })`
  appearance: none;
  border: 0;
  padding: 0;
  min-width: 0;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  &:disabled { opacity: .65; cursor: wait; }
  flex: 1;
  height: 48px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
  font-family: var(--font-Pretendard-Bold);
  font-size: 15px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
`;

const ReviewLoginForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  text-align: left;
  label { color: var(--user-text); font-size: 14px; }
  input { min-height: 44px; padding: 10px 12px; border: 1px solid var(--user-border); border-radius: 8px; background: var(--user-surface-muted); color: var(--user-text); font: inherit; font-size: 16px; }
  input:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  span { color: var(--user-error); font-size: 13px; line-height: 1.4; }
  button { min-height: 44px; margin-top: 4px; border: 0; border-radius: 8px; color: #fff; background: linear-gradient(135deg, #7955f0, #3209b9); font: inherit; font-weight: 700; cursor: pointer; }
  button:disabled { opacity: .6; cursor: wait; }
`;

const ReviewCheckoutAlert = styled.div`
  position: absolute;
  top: 38px;
  right: 0;
  width: 260px;
  padding: 10px 12px;
  border-radius: 8px;
  background: var(--user-error-soft);
  border: 1px solid var(--user-error);
  color: var(--user-error);
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 6px 16px rgba(0, 0, 0, .28);
  button { display: block; margin-top: 6px; padding: 0; border: 0; background: none; color: var(--user-accent); font: inherit; font-weight: 700; text-decoration: underline; cursor: pointer; }
`;
